<template>
  <div class="body">
    <div class="bg-white p20">

      <div class="f--c mb20">
        <h2>
          基本信息
        </h2>
      </div>
      <el-form ref="form" :rules="rules" :model="form" label-width="80px" style="margin-top: 20px">
        <el-row>
          <el-col :span="12" class="pr20">
            <el-form-item label="教师姓名" prop="name" class="item">
              <el-input
                :disabled="$route.query.type == 'check'"
                v-model="form.name"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12" class="pr20">
            <el-form-item label="擅长领域" prop="lable" class="item">
              <el-input
                :disabled="$route.query.type == 'check'"
                v-model="form.lable"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12" class="pr20">
            <el-form-item label="电话" prop="phone" class="item">
              <el-input
                :disabled="$route.query.type == 'check'"
                v-model="form.phone"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12" class="pr20">
            <el-form-item label="工作年限" prop="professionalWorkingYears" class="item">
              <el-input-number
                v-model="form.professionalWorkingYears"
                :min="1"
                :max="100"
                label="工作年限"
                :disabled="$route.query.type == 'check'"
              ></el-input-number>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12" class="pr20">
            <el-form-item label="工作类型" prop="jobType" class="item">
              <el-radio-group v-model="form.jobType"  :disabled="$route.query.type == 'check'">
                <el-radio :label="1">全职</el-radio>
                <el-radio :label="2">兼职</el-radio>
              </el-radio-group>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12" class="pr20">
            <el-form-item label="教师图片" prop="picture">
              <template v-if="$route.query.type == 'check'">
                <img width="150px" :src="upload.dialogImageUrl" alt="">
              </template>
              <template v-else>
                <el-upload-e
                  :dir="ossConstant.dir.teacherImage"
                  :limit="upload.imgLimit"
                  :fileList="upload.productImgs"
                  @onSuccess="handleAvatarSuccess"
                  @onRemove="handleRemove"
                  :accept="'.png,.jpg'"
                ></el-upload-e>
              </template>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12" class="pr20">
            <el-form-item label="详情" prop="description">
              <quillEditor
                v-if="$route.query.type != 'check'"
                v-model="form.description"
                ref="myQuillEditor"
                :options="editorOption"
              ></quillEditor>
              <div v-else v-html="form.description"></div>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12" class="pr20">
            <el-form-item label="备注" prop="remarks" class="item">
              <el-input
                type="textarea"
                :disabled="$route.query.type == 'check'"
                v-model="form.remarks"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
<!--        <el-row>-->
<!--          <el-col :span="6" class="pr20">-->
<!--            <el-form-item label="排序" prop="sort" class="item">-->
<!--              <el-tooltip content="按升序排列" placement="top">-->
<!--                <el-input-number-->
<!--                  v-model="form.sort"-->
<!--                  :min="1"-->
<!--                  :max="1000"-->
<!--                  label="升序"-->
<!--                  :disabled="$route.query.type == 'check'"-->
<!--                ></el-input-number>-->
<!--              </el-tooltip>-->
<!--            </el-form-item>-->
<!--          </el-col>-->
<!--        </el-row>-->
        <div class="f--c mb20">
          <h2>
            证件信息
          </h2>
        </div>
        <el-row>
          <el-col :span="12" class="pr20">
            <el-form-item label="证书编号" prop="certificateNo" class="item">
              <el-input
                :disabled="$route.query.type == 'check'"
                v-model="form.certificateNo"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12" class="pr20">
            <el-form-item label="考核部门" prop="assessmentDepartment" class="item">
              <el-input
                :disabled="$route.query.type == 'check'"
                v-model="form.assessmentDepartment"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12" class="pr20">
            <el-form-item label="考核时间" prop="assessmentDate" class="item">
              <el-date-picker
                :disabled="$route.query.type == 'check'"
                v-model="form.assessmentDate"
                align="right"
                type="date"
                placeholder="选择日期">
              </el-date-picker>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12" class="pr20">
            <el-form-item label="考核结果" prop="assessmentResults" class="item">
              <el-input
                :disabled="$route.query.type == 'check'"
                v-model="form.assessmentResults"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <div class="searchBut" style="margin-top: 15px;  text-align: center">
        <el-button
          v-if="$route.query.type == 'edit' || $route.query.type == 'add'"
          type="primary"
          @click="save"
          :loading="saveLoading"
        >保存
        </el-button
        >
        <el-button type="primary" @click="$router.back(-1)">返回</el-button>
      </div>
    </div>
  </div>
</template>

<script>
import api from "../../api/new/training.js";
import api_user from "../../api/api_user.js";
import exam from "@/api/new/exam.js";
import selectTree from "@/components/common/selectTree";
import {quillEditor} from "vue-quill-editor";
import elUploadE from "@/components/common/oss/ossUploadMultiple";
import $ossConstant from "@/components/common/oss/ossConstant";

/*富文本编辑图片上传配置*/
const uploadConfig = {
  action: process.env.API_ROOT + "/clouddo-tranning/training/record/upload", // 必填参数 图片上传地址
  methods: "POST", // 必填参数 图片上传方式
  // token: window.localStorage.getItem("access-token"), // 可选参数 如果需要token验证，假设你的token有存放在sessionStorage
  name: "file", // 必填参数 文件的参数名
  size: 500, // 可选参数   图片大小，单位为Kb, 1M = 1024Kb
  accept: "image/png, image/gif, image/jpeg, image/bmp, image/x-icon" // 可选 可上传的图片格式
};
const handlers = {
  image: function image() {
    var self = this;

    var fileInput = this.container.querySelector("input.ql-image[type=file]");
    if (fileInput === null) {
      fileInput = document.createElement("input");
      fileInput.setAttribute("type", "file");
      // 设置图片参数名
      if (uploadConfig.name) {
        fileInput.setAttribute("name", uploadConfig.name);
      }
      // 可设置上传图片的格式
      fileInput.setAttribute("accept", uploadConfig.accept);
      fileInput.classList.add("ql-image");
      // 监听选择文件
      fileInput.addEventListener("change", function () {
        // 创建formData
        var formData = new FormData();
        formData.append(uploadConfig.name, fileInput.files[0]);
        formData.append("object", "product");
        // 如果需要token且存在token
        if (uploadConfig.token) {
          formData.append("token", uploadConfig.token);
        }
        // 图片上传
        var xhr = new XMLHttpRequest();
        xhr.open(uploadConfig.methods, uploadConfig.action, true);
        xhr.setRequestHeader(
          "Authorization",
          window.localStorage.getItem("access-token")
        );
        // 上传数据成功，会触发
        xhr.onload = function (e) {
          if (xhr.status === 200) {
            var res = JSON.parse(xhr.responseText);
            let length = self.quill.getSelection(true).index;
            //这里很重要，你图片上传成功后，img的src需要在这里添加，res.path就是你服务器返回的图片链接。
            console.log(res.data);
            self.quill.insertEmbed(length, "image", "http://" + res.data);
            self.quill.setSelection(length + 1);
          }
          fileInput.value = "";
        };
        // 开始上传数据
        xhr.upload.onloadstart = function (e) {
          fileInput.value = "";
        };
        // 当发生网络异常的时候会触发，如果上传数据的过程还未结束
        xhr.upload.onerror = function (e) {
        };
        // 上传数据完成（成功或者失败）时会触发
        xhr.upload.onloadend = function (e) {
          // console.log('上传结束')
        };
        xhr.send(formData);
      });
      this.container.appendChild(fileInput);
    }
    fileInput.click();
  }
};
// toolbar工具栏的工具选项（默认展示全部）
const toolOptions = [
  ["bold", "italic", "underline", "strike"],
  ["blockquote", "code-block"],
  [{header: 1}, {header: 2}],
  [{list: "ordered"}, {list: "bullet"}],
  [{script: "sub"}, {script: "super"}],
  [{indent: "-1"}, {indent: "+1"}],
  [{direction: "rtl"}],
  [{size: ["small", false, "large", "huge"]}],
  [{header: [1, 2, 3, 4, 5, 6, false]}],
  [{color: []}, {background: []}],
  [{font: []}],
  [{align: []}],
  ["clean"],
  ["image"]
];

export default {
  components: {quillEditor, selectTree, elUploadE},
  data() {
    return {
      id: undefined, //
      type: undefined, //
      ossConstant: $ossConstant,
      form: {
        trainingName: undefined,
        label: undefined,
        sort: undefined,
        picture: undefined,
        description: undefined,
        phone: undefined,
        professionalWorkingYears: 1,
        jobType: 1,

        certificateNo: undefined,
        assessmentDepartment: undefined,
        assessmentDate: undefined,
        assessmentResults: undefined,
        remarks: undefined
      },
      rules: {
        name: [
          {required: true, message: "请输入教师名称", trigger: "blur"},
          {min: 1, max: 32, message: '长度在 1 到 32 个字符', trigger: 'blur'}
        ],
        lable: [{required: true, message: "请输入教师擅长领域", trigger: "blur"},
          {min: 1, max: 100, message: '长度在 1 到 100 个字符', trigger: 'blur'}
        ],
        sort: [{required: true, message: "请输入排序", trigger: "blur"}],
        picture: [{required: true, message: "请上传图片"}],
        description: [{required: true, message: "请输入教师宣传信息"}],

        phone: [{required: true, message: "请输入电话", trigger: "blur"},
          {min: 1, max: 100, message: '长度在 1 到 11 个字符', trigger: 'blur'}
        ],
        professionalWorkingYears: [{required: true, message: "请输入教师工作年限", trigger: "blur"}],
        jobType: [{required: true, message: "请选择工作类型", trigger: "blur"}],

        certificateNo: [{required: true, message: "请输入证书编号", trigger: "blur"}],
        assessmentDepartment: [{required: true, message: "请输入考核部门", trigger: "blur"}],
        assessmentDate: [{required: true, message: "请选择考核时间", trigger: "blur"}],
        assessmentResults: [{required: true, message: "请输入考核结果", trigger: "blur"}],

      },
      saveLoading: false,
      page: 1,
      pageSize: 10,
      total: 0, // 总条数
      page2: 1,
      pageSize2: 20,
      total2: 0,
      upload: {
        dialogImageUrl: '',
        dialogVisible: false,
        productImgs: [],
        isMultiple: true,
        imgLimit: 1,
        action: process.env.API_ROOT + "/api-base/sysAtt/save"
      },
      editorOption: {
        //  富文本编辑器配置
        placeholder: "",
        theme: "snow", // 主题
        modules: {
          // 新增下面
          imageDrop: true, // 拖动加载图片组件。
          imageResize: {
            //调整大小组件。
            displayStyles: {
              backgroundColor: "black",
              border: "none",
              color: "white"
            },
            modules: ["Resize", "DisplaySize", "Toolbar"]
          },
          toolbar: {
            container: toolOptions, // 工具栏选项
            // handlers: handlers // 事件重写
          }
        },
        history: {
          delay: 1000,
          maxStack: 50,
          userOnly: false
        },
        imageDrop: true,
        imageResize: {
          displayStyles: {
            backgroundColor: "black",
            border: "none",
            color: "white"
          },
          modules: ["Resize", "DisplaySize", "Toolbar"]
        }
      },
    };
  },
  mounted() {
    this.id = this.$route.query.id;
    this.type = this.$route.query.type;
    if (this.id) this.getDetail();
    this.uploadUrl =
      process.env.API_ROOT + "/clouddo-tranning/training/resources/data/upload";
    this.headers.Authorization = window.localStorage.getItem("access-token");
  },
  methods: {
    getDetail() {
      api.detailsTeacher({id: this.id}).then(res => {
        this.form = {
          name: res.data.name,
          lable: res.data.lable,
          picture: res.data.picture,
          description: res.data.description,
          sort: 1,

          phone: res.data.phone,
          professionalWorkingYears: res.data.professionalWorkingYears,
          jobType: res.data.jobType,
          certificateNo: res.data.certificateNo,
          assessmentDepartment: res.data.assessmentDepartment,
          assessmentDate: res.data.assessmentDate,
          assessmentResults: res.data.assessmentResults,
          remarks: res.data.remarks
        }
        if (res.data.assessmentDate) {
          this.form.assessmentDate = new Date(res.data.assessmentDate).getTime();
        }
        this.upload.dialogImageUrl = res.data.pictureUrl;
        // 图片回显
        this.upload.productImgs = [
          {
            id: res.key,
            name: '教师图片',
            hash: res.data.pictureUrl,
            url: res.data.pictureUrl
          }
        ];
      });
    },
    save() {
      this.$refs.form.validate(validate => {
        if (validate == false) return;


        let p = {
          ...this.form,
        };
        if (this.id) p.id = this.id;
        if (this.form.assessmentDate) {
          p.assessmentDate = new Date(this.form.assessmentDate).getTime();
        }
        this.saveLoading = true;
        api.saveTeacher(p).then(res => {
          if (res.code == 0) {
            this.$message.success("成功");
            this.$router.go(-1);
          } else {
            this.saveLoading = false;
            this.$message.error(res.message);
          }
        });
      });
    },
    //上传文件成功回调
    uploadSuccess(e) {
      if (e.code == 0) {
        this.annexList.push(e.data);
      } else {
        this.$message.error(e.message);
      }
    },
    delData(index) {
      this.$confirm("此操作将删除, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(() => {
        this.dataList2.splice(index, 1);
      });
    },
    //重置表单
    resetForm(formName) {
      console.log(formName);
      this.$refs[formName].resetFields();
    },
    //  图片上传回调代码
    handleRemove(file, fileList) {//移除图片
      this.form.picture = undefined;
    },
    handlePictureCardPreview(file) {//预览图片时调用
      this.upload.dialogImageUrl = file.url;
      this.upload.dialogVisible = true;
    },
    beforeAvatarUpload(file) {//文件上传之前调用做一些拦截限制
      console.log(file);
      const isJPG = true;
      // const isJPG = file.type === 'image/jpeg';
      const isLt2M = file.size / 1024 / 1024 < 2;

      // if (!isJPG) {
      //   this.$message.error('上传头像图片只能是 JPG 格式!');
      // }
      if (!isLt2M) {
        this.$message.error('上传图片大小不能超过 2MB!');
      }
      return isJPG && isLt2M;
    },
    handleAvatarSuccess(res, data) {//图片上传成功
      this.form.picture = data.name;
    },
    handleExceed(files, fileList) {//图片上传超过数量限制
      this.$message.error('只能上传' + this.upload.imgLimit + '张图片');
      console.log(file, fileList);
    },
    imgUploadError(err, file, fileList) {//图片上传失败调用
      console.log(err)
      this.$message.error('上传图片失败!');
    }
  },
  watch: {
    "form.departmentId": function (deptId) {
      api_user.getByDept({deptId}).then(res => {
        this.principalList = res.data;
      });
    }
  },
  created() {
    // 新增排序默认为  1
    if (this.$route.query.type == 'add') {
      this.form = {
        sort: 1,
        professionalWorkingYears: 1,
        jobType: 1
      };
    }
  }
};
</script>

<style>
.el-form-item__label {
  white-space: nowrap;
}

.required {
  color: red;
}

.hr {
  height: 2px;
  background: #e4e4e4;
  flex: 1;
  margin-left: 20px;
}
</style>



// WEBPACK FOOTER //
// src/pages/trainingManagement/addTeacher.vue